import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var SuccessSelectionIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 14 11" }),
        React.createElement("path", { d: "M4.32199 8.46875L1.42256 5.57708C1.09669 5.25208 0.570277 5.25208 0.244405 5.57708C-0.0814682 5.90208 -0.0814682 6.42708 0.244405 6.75208L3.73709 10.2354C4.06297 10.5604 4.58938 10.5604 4.91525 10.2354L13.7556 1.41875C14.0815 1.09375 14.0815 0.56875 13.7556 0.24375C13.4297 -0.08125 12.9033 -0.08125 12.5774 0.24375L4.32199 8.46875Z" })));
};

export { SuccessSelectionIcon };
//# sourceMappingURL=SuccessSelectionIcon.esm.js.map
